import RouteStoppageMapModal from "./RouteStoppageMapModal";

const RouteStoppageMapModalHost = ({
  showModal,
  activeStoppageIndex,
  setActiveStoppageIndex,
  onCloseStoppageMap,
  routeId = 0,
  routePoints,
  stoppages,
  onSaveStoppage,
}) => {
  const isAddingNew = activeStoppageIndex === -1;
  const isEditing =
    activeStoppageIndex !== null && activeStoppageIndex >= 0;
  const isOpen = showModal && (isAddingNew || isEditing);

  const handleClose = () => {
    if (onCloseStoppageMap) {
      onCloseStoppageMap();
      return;
    }
    setActiveStoppageIndex(null);
  };

  return (
    <RouteStoppageMapModal
      show={isOpen}
      onHide={handleClose}
      stoppageIndex={isAddingNew ? stoppages.length : activeStoppageIndex ?? 0}
      routeId={routeId}
      routePoints={routePoints}
      saveToApi
      existingStoppages={
        isAddingNew
          ? stoppages.filter((item) => item.latitude && item.longitude)
          : stoppages.filter(
              (item, itemIndex) =>
                itemIndex !== activeStoppageIndex &&
                item.latitude &&
                item.longitude
            )
      }
      initialStoppage={
        isEditing ? stoppages[activeStoppageIndex] ?? {} : {}
      }
      onSave={onSaveStoppage}
    />
  );
};

export default RouteStoppageMapModalHost;
